module.exports = __webpack_public_path__ + "img/三一互联全国总部大楼2.b739ad43.png";